import { useQueryClient } from "react-query";
import { deleteThread } from "../api"
import { DISCUSSION_LIST_CACHE_KEY } from "./useDiscussionList";
import { useState } from "react";

export const useDeleteThread = () => {
  const client = useQueryClient();
  const [isDeleting, setIsDeleting] = useState(false);

  const _deleteThread = async (id: string) => {
    setIsDeleting(true);
    try {
      await deleteThread(id);
    } catch {
    }
    
    setIsDeleting(false);

    client.refetchQueries(DISCUSSION_LIST_CACHE_KEY);
  }

  return {
    deleteThread: _deleteThread,
    isDeleting
  }
}